import { useMutation } from '@tanstack/react-query'
import { AdminService } from '@app/services/adminService'
import { toast } from '@app/components/ui/Toast/toast'
import type { UserRole } from '@app/types'
import { queryClient } from '@app/config/queryClient'
import { USERS_QUERY_KEY } from '../utils/Admin.constants'

export const useUpdateUserRoles = () => {
  return useMutation({
    mutationFn: ({
      uuid,
      clientName,
      roles,
    }: {
      uuid: string
      clientName: string
      roles: UserRole[]
    }) => AdminService.updateUserRole(uuid, clientName, roles),
    onSuccess: () => {
      toast({
        description: `User roles updated successfully.`,
        type: 'success',
      })
      queryClient.invalidateQueries({ queryKey: [USERS_QUERY_KEY] })
    },
    onError: () =>
      toast({
        description: `Failed to update user roles.`,
        type: 'error',
      }),
  })
}
